// Privacy masking for session recorders (Yandex Metrica Webvisor / rrweb).
// Automatically tags sensitive inputs so their keystrokes/content are NOT recorded:
//  - ym-disable-keys : Yandex Metrica Webvisor stops recording keystrokes
//  - rr-mask / rr-ignore : rrweb masks content / ignores input events
// Data still reaches OUR backend as usual — only 3rd-party recorders are blinded.

const SENSITIVE_SELECTOR = [
  'input[type="tel"]',
  'input[type="password"]',
  'input[id*="phone" i]',
  'input[name*="phone" i]',
  '[data-testid*="phone"]',
  'input[autocomplete^="cc-"]',
  'input[id*="card" i]',
  'input[name*="card" i]',
].join(', ');

const MASK_CLASSES = ['ym-disable-keys', 'rr-mask', 'rr-ignore'];

function tagSensitiveInputs(root) {
  const nodes = root.querySelectorAll
    ? root.querySelectorAll(SENSITIVE_SELECTOR)
    : [];
  nodes.forEach((el) => {
    MASK_CLASSES.forEach((cls) => el.classList.add(cls));
  });
}

export function initPrivacyMask() {
  // Initial pass
  tagSensitiveInputs(document);

  // Watch for React-rendered inputs appearing later
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType === 1) {
          if (node.matches && node.matches(SENSITIVE_SELECTOR)) {
            MASK_CLASSES.forEach((cls) => node.classList.add(cls));
          }
          tagSensitiveInputs(node);
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}
